import Menu from './Compartido/Menu.jsx';
import TextosSobreNosotros from './SobreNosotros/TextosSobreNosotros.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const SobreNosotros = (props) => {
    return (
        <main>
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina="5_Sobre-Nosotros"
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <TextosSobreNosotros
                lang={props.lang}
                sobrenosotros={props.textosobrenosotros}
            />
            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Scripts />
        </main>
    )
}
export default SobreNosotros;

